import PatientCaseContainer from './PatientCaseContainer';

export default PatientCaseContainer;
